module.exports = {"371427001":"银城街道","371427002":"北城街道","371427100":"南城镇","371427101":"苏留庄镇","371427102":"新盛店镇","371427103":"雷集镇","371427104":"郑保屯镇","371427105":"白马湖镇","371427106":"东李官屯镇","371427107":"宋楼镇","371427108":"香赵庄镇","371427109":"双庙镇","371427200":"渡口驿乡","371427204":"田庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371427.json
// module id = 1479
// module chunks = 0